export const LoremIpsum = {
  LONG: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi laoreet arcu orci,
  dignissim pharetra lacus blandit nec. Curabitur est quam, condimentum id ornare at,
  semper vitae mi. Nulla facilisi. Phasellus ex odio, malesuada a est viverra, laoreet
  lacinia velit.`,
  SHORT: 'Lorem ipsum dolor',
  MEDIUM: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
};
